/* eslint-disable import/no-cycle */
/* eslint-disable react/prop-types */
import React, { useRef, useState, useEffect } from "react";
import "./canvasComponent.scss";
import { IconType } from "../../atoms/icon/icon";
import { IconSize } from "../../atoms/icon/icon";
import Button, {
  ButtonSize,
  ButtonTheme,
  ButtonType,
} from "../../atoms/button/button";
import swal from "sweetalert";
import sportRoomIcon from "../../atoms/customIcons/sportRoomIcon.svg";
import calendarIcon from "../../atoms/customIcons/calendarIcon.svg";
import staticImageIcon from "../../atoms/customIcons/staticImageIcon.svg";
import highlightedContentIcon from "../../atoms/customIcons/highlightedContentIcon.svg";
import externalVideoIcon from "../../atoms/customIcons/externalVideoIcon.svg";
import carouselIcon from "../../atoms/customIcons/carouselIcon.svg";
import spacesCarouselIcon from "../../atoms/customIcons/spacesCarouselIcon.svg";
import contentCategoryIcon from "../../atoms/customIcons/contentCategoryIcon.svg";
import contentApp2AppTravelIcon from "../../atoms/customIcons/contentApp2AppTravelIcon.svg";
import interactableGraphicsIcon from "../../atoms/customIcons/interactableGraphicsIcon.svg";
import alertIcon from "../../atoms/customIcons/alertIcon.svg";
import infoIcon from "../../atoms/customIcons/infoIcon.svg";
import { httpGet, httpPost } from "../../../store/externalCalls/httpCalls";
import FormPopup from "../../molecules/formPopup/formPopup";
import FormInputTypes from "../../atoms/formEnums/formInputTypes";
import viewSportsRoomSelectable from "../../../config/viewSportsRoomSelectable";
import viewHighlightedContentSelectable from "../../../config/viewHighlightedContentSelectable";
import { storeStructure } from "../../../store/reducers";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import viewHighlightedContentMultiSelectable from "../../../config/viewHighlightedContentMultiSelectable";
import viewsportRoomContentMultiSelectable from "../../../config/viewSportRoomContentMultiSelectable";
import viewRelatedAppContentsMultiselectable from "../../../config/viewRelatedAppContentsMultiselectable";
import viewRelatedAppCategoriesContent from "../../../config/viewRelatedAppCategoriesContent";
import {
  getCanvasBlockSize,
  getLongSize,
  loadInfoBlock,
  randomNumberInRange,
} from "../../../utils/canvasUtils";
import viewHighlightedContentAppSelectable from "../../../config/viewHighlightedContentAppSelectable";
import noImageXXL from "../../atoms/customIcons/noImages/XXL_Block.jpg";
import noImageXXLCarousel from "../../atoms/customIcons/noImages/XXL_Carousel.jpg";
import noImageXLV from "../../atoms/customIcons/noImages/XLV_Block.jpg";
import noImageXLVCarousel from "../../atoms/customIcons/noImages/XLV_Carousel.jpg";
import noImageXLH from "../../atoms/customIcons/noImages/XLH_Block.jpg";
import noImageXLHCarousel from "../../atoms/customIcons/noImages/XLH_Carousel.jpg";
import noImageLV from "../../atoms/customIcons/noImages/LV_Block.jpg";
import noImageLVCarousel from "../../atoms/customIcons/noImages/LV_Carousel.jpg";
import noImageLH from "../../atoms/customIcons/noImages/LH_Block.jpg";
import noImageLHCarousel from "../../atoms/customIcons/noImages/LH_Carousel.jpg";
import noImageM from "../../atoms/customIcons/noImages/M_Block.jpg";
import noImageMCarousel from "../../atoms/customIcons/noImages/M_Carousel.jpg";
import noImageSV from "../../atoms/customIcons/noImages/SV_Block.jpg";
import noImageSVCarousel from "../../atoms/customIcons/noImages/SV_Block.jpg";
import noImageSH from "../../atoms/customIcons/noImages/SH_Block.jpg";
import noImageSHCarousel from "../../atoms/customIcons/noImages/SH_Block.jpg";
import noImageXS from "../../atoms/customIcons/noImages/XS_Block.jpg";
import noImageXSCarousel from "../../atoms/customIcons/noImages/XS_Block.jpg";

import noImageSFWCarousel from "../../atoms/customIcons/noImages/XS_Block.jpg";
import noImageSFW from "../../atoms/customIcons/noImages/FW_Block.jpg";

import videoPosterNoImage from "../../atoms/customIcons/noImages/Categorized_content_poster.jpg";
import { removeCanvasContentInfo } from "../../../store/actions/canvasContentInfoActions";
import IframeCustom from "../../atoms/customIframe/customIframe";
import formStaticImage from "../../../config/components/formStaticImage";
import formInteractableGraphics from "../../../config/components/formInteractableGraphics";
import viewExternalContentAppSelectable from "../../../config/viewExternalContentAppSelectable";
import viewExternalContentAppMultiSelectable from "../../../config/viewExternalContentAppMultiSelectable";
import CanvasPreviewImage from "./canvasPreviewImage";
import CanvasComponent from '../canvasComponent/canvasComponent';
/**
 * Canvas Content component
 */
const CanvasContentComponent = (props) => {
  const {
    isScrollable,
    canvasId,
    contentId,
    mode,
    canvasMode,
    size,
    value,
    infoContent,
    onUpdateContent,
    onInfoClicked,
    onBlockBlocks,
    isInit,
    onUpdateInfoContent,
    blockSelectedPreview,
    containerId,
  } = props;
  const [showContentMode, setShowContentMode] = useState("new");

  const [showContentPopup, setShowContentPopup] = useState(false);
  const [showContentTypePopup, setShowContentTypePopup] = useState(false);
  const [contentPopupTypeConfig, setContentPopupTypeConfig] = useState(null);
  const [contentPopupConfig, setContentPopupConfig] = useState(null);
  const [contentPopupValue, setContentPopupValue] = useState(null);
  const [contentPopupTypeValue, setContentPopupTypeValue] = useState(null);
  const [contentPopupIcon, setContentPopupIcon] = useState(null);
  const [contentPopupSuperTitle, setContentPopupSuperTitle] = useState(null);
  const [viewSelectionPopup, setViewSelectionPopup] = useState(false);
  const [viewSelectionType, setViewSelectionType] = useState(false);
  const [viewSelectionUrl, setViewSelectionUrl] = useState(null);
  const [viewSelectionId, setViewSelectionId] = useState(null);
  const [viewSelectionResultField, setViewSelectionResultField] = useState(
    null
  );
  const [viewSelectionParams, setViewSelectionParams] = useState(null);
  const [carouselSelected, setCarouselSelected] = useState([]);
  const [carouselImageSelected, setCarouselImageSelected] = useState(null);
  const [categoryContentSelected, setCategoryContentSelected] = useState([]);
  const [infoBlock, setInfoBlock] = useState(null);
  const { session, CanvasInfoContent } = useSelector(
    (state) => ({
      session: state[storeStructure.Session],
      CanvasInfoContent: state[storeStructure.CanvasContentInfo],
    }),
    shallowEqual
  );


  const [imagesLoaded, setImagesLoaded] = useState([]);
  const dispatch = useDispatch();
  const isAndroidXR = session?.operatingSystem === "androidXR";
  

  useEffect(() => {}, [value, infoContent]);

  useEffect(() => {
    let found =
      value &&
      value.contents &&
      CanvasInfoContent &&
      CanvasInfoContent.find((item) => item.UID == value.contents.UID);
    if (found) {
      setInfoBlock(found);
    }
  }, [CanvasInfoContent]);

  useEffect(() => {
    if (mode == 2) {
      //mode preview
      if (value.contents) {
        let found =
          CanvasInfoContent &&
          CanvasInfoContent.find((item) => item.UID == value.contents.UID);
        if (!found) {
          // console.log("not found INFO!!!!!! so we load info for content ...",value.contents);
          loadInfoBlock(value, session,isScrollable, (info) => {
            let newElement = JSON.parse(JSON.stringify(value.contents));
            newElement.info = info;
            onUpdateInfoContent(newElement, infoContent);
          });
        } else {
          setInfoBlock(found);
        }
      }
    }
  }, [mode]);
  
  const getConfigContent = (type, canvasContainerId) => {
    let queryString = window.location.pathname;
    let isSportRoom = false;
    if (queryString.search("sportrooms") >= 0) {
      isSportRoom = true;
    }
    if (type) {
      let config = "";
      switch (type) {
        case "staticImage":
          config = formStaticImage;
          break;
        case "interactableGraphics":
  config = [
    {
      attributeName: "content",
      fields: [
        {
          attributeName: "interactableGraphicSelector",
          helpText: "Interactable graphic selector",
          type: FormInputTypes.INTERACTABLEGRAPHICSELECTOR,
          label: "Interactable graphic",
          placeholder:
            "Please enter to add an interactable graphic ...",
          place: "canvas" + canvasMode,
        },
        {
          attributeName: "scalingFactor",
          label: "Scaling Factor",
          helpText:
            "The scale factor to define the resolution on client.",
          default:[1],
          type: FormInputTypes.SELECT,
          options: [
            { name: "Default (1x)", value: 1 },
            { name: "Medium (1.5x)", value: 1.5 },
            { name: "High (2x)", value: 2 },
          ],
        },
        ...(isAndroidXR
          ? [
              {
                attributeName: "height",
                label: "Height",
                type: FormInputTypes.NUMBER,
                helpText: "Set the height for Android XR canvas elements",
                default: 306,
                placeholder: "Enter height in px",
              },
            ]
          : []),
      ],
    },
  ];
  break;
        case "calendar":
          config = [
            {
              attributeName: "content",
              fields: [
                {
                  attributeName: "maxNumElements",
                  type: FormInputTypes.TEXT_INPUT.TEXT,
                  label: "Max num of elements",
                  placeholder: "Select the max number of elements...",
                  default: "10",
                  pattern: /^[0-9\b]+$/,
                },
                {
                  attributeName: "configId",
                  type: FormInputTypes.TEXT_INPUT.TEXT,
                  label: "ConfigId",
                  placeholder: "Config selected...",
                  default: "0",
                  hidden: true,
                },
              ],
            },
          ];
          break;
        case "sportRoom":
          config = [
            {
              attributeName: "content",
              fields: [
                {
                  attributeName: "tableValue", //don´t change this name
                  label: "Choose Content Type",
                  type: FormInputTypes.TABLE2,
                  canEdit: true,
                  canCreate: true,
                  configFile: viewSportsRoomSelectable,
                  itemName: "name",
                  itemId: "id",
                  default: {},
                  helpText: "Select the content to show on the side block",
                },
              ],
            },
          ];
          //to adapt mainhub and sportroom with spacesapi need to be removed and get everything from rooms and remove mainhub
            config[0].fields[0].configFile.getURL = "room/appId/canvas/" + canvasId + "/roomsPaginated";
            config[0].fields[0].configFile.sessionParams = ["appId"];
          break;
        case "carousel":
          config = [
            {
              attributeName: "content",
              fields: [
                {
                    attributeName: 'title',
                    helpText: 'Optional title for this carousel',
                    type: FormInputTypes.TEXT_INPUT.TEXT,
                    label: 'Title (optional)',
                    placeholder: 'Title...',
                },
                {
                  attributeName: "backgroundImage",
                  helpText: "Image selector",
                  type: FormInputTypes.DOWNLOADABLE,
                  label: "Spaces Carousel Background",
                  placeholder: "Please enter a Background Image ...",
                  fileType: [".png", ".jpg"],
                  valueField: "id",
                },
                {
                  attributeName: "tableValue", //don´t change this name
                  label: "Choose contents for the carousel",
                  type: FormInputTypes.TABLE2,
                  canEdit: true,
                  canCreate: true,
                  configFile:viewExternalContentAppMultiSelectable,
                  itemName: "name",
                  itemId: "id",
                  default: {},
                  helpText: "Select the content to show on the side block",
                },
              ],
            },
          ];
          config[0].fields[2].configFile.getURL ="externalContent/appId/canvas/"+canvasId;
          break;
        case "spacesCarousel":
          config = [
            {
              attributeName: "content",
              fields: [
                {
                  attributeName: "backgroundImage",
                  helpText: "Image selector",
                  type: FormInputTypes.DOWNLOADABLE,
                  label: "Spaces Carousel Background",
                  placeholder: "Please enter a Background Image ...",
                  fileType: [".png", ".jpg"],
                  valueField: "id",
                },
                {
                  attributeName: "tableValue", //don´t change this name
                  label: "Choose contents for the space carousel",
                  type: FormInputTypes.TABLE2,
                  canEdit: true,
                  canCreate: true,
                  configFile: viewsportRoomContentMultiSelectable,
                  itemName: "name",
                  itemId: "id",
                  default: {},
                  helpText: "Select the content to show on the side block",
                },
              ],
            },
          ];        
          config[0].fields[1].configFile.getURL ="room/appId/canvas/" + canvasId + "/roomsPaginated";
          config[0].fields[1].configFile.sessionParams = ["appId"];
          break;
        case "contentCategory":
          config = [
            {
              attributeName: "content",
              fields: [
                {
                  attributeName: "allCategories",
                  label: "All categories",
                  helpText: "Select all categories.",
                  default: false,
                  type: FormInputTypes.CHECKBOX,
                },
                {
                  attributeName: "tableValue", //don´t change this name
                  label: "Choose Categories",
                  type: FormInputTypes.TABLE2,
                  canEdit: true,
                  canCreate: true,
                  configFile: viewRelatedAppCategoriesContent,
                  itemName: "name",
                  itemId: "id",
                  default: {},
                  helpText: "Select the content to show on the side block",
                },
              ],
            },
          ];
          break;
        case "highlightedContent":
          config = [
            {
              attributeName: "content",
              fields: [
                {
                  attributeName: "tableValue", //don´t change this name
                  label: "Choose highlighted Content",
                  type: FormInputTypes.TABLE2,
                  canEdit: true,
                  canCreate: true,
                  configFile:
                    isSportRoom == true
                      ? viewExternalContentAppSelectable
                      : viewHighlightedContentSelectable,
                  itemName: "name",
                  itemId: "id",
                  default: {},
                  helpText: "Select the content to show on the side block",
                },
              ],
            },
          ];
          if (isSportRoom) {
            config[0].fields[0].configFile.getURL ="externalContent/appId/canvas/"+canvasId;
          }
          break;
        case "App2AppTravel":
          config = [
            {
              attributeName: "content",
              fields: [
                {
                  attributeName: "applicationId",
                  type: FormInputTypes.TEXT_INPUT.TEXT,
                  label: "Application ID",
                  placeholder: "Application id...",
                  default: "",
                },
                {
                  attributeName: "destinationApiName",
                  type: FormInputTypes.TEXT_INPUT.TEXT,
                  label: "Destination Api name",
                  placeholder: "Destination api name...",
                  default: "",
                },
                {
                  attributeName: "lobbyId",
                  type: FormInputTypes.TEXT_INPUT.TEXT,
                  label: "Lobby ID",
                  placeholder: "Application id...",
                  default: "",
                },
                {
                  attributeName: "matchId",
                  type: FormInputTypes.TEXT_INPUT.TEXT,
                  label: "Match ID",
                  placeholder: "Match id...",
                  default: "",
                },
                {
                  attributeName: "deepLinkMessage",
                  type: FormInputTypes.TEXT_INPUT.TEXT,
                  label: "Depplink message",
                  placeholder: "Deeplink message...",
                  default: "",
                },
                {
                  attributeName: "defaultId",
                  type: FormInputTypes.DOWNLOADABLE,
                  label: "Default Image",
                  helpText: "  Select default image information.",
                  fileType: ["image/*"],
                  hasSelect: false,
                },
                {
                  attributeName: "secondaryId",
                  type: FormInputTypes.DOWNLOADABLE,
                  label: "Secondary Image",
                  helpText: "  Select secondary image information.",
                  fileType: ["image/*"],
                  hasSelect: false,
                },
                {
                  attributeName: "overrideDeeplink",
                  label: "Override deeplink",
                  helpText:
                    "Check this field to overide the data by the deeplink.",
                  default: false,
                  type: FormInputTypes.CHECKBOX,
                },
              ],
            },
          ];
          break;
      }
      return config;
    }
  };
  const handleCloseContentTypePopup = (type) => {
    if (type != null) {
      let config = getConfigContent(type, value.canvasContainerId);
      setContentPopupValue({
        type: type,
        canvasContainerId: value.canvasContainerId,
      });
      setContentPopupConfig(config);
      setContentPopupIcon(getType(type, size));

      setContentPopupSuperTitle(getType(type, size, true));
      setViewSelectionType(type);
      if (
        type == "sportRoom" ||
        type == "highlightedContent" ||
        type == "carousel" ||
        type == "contentCategory" ||
        type == "spacesCarousel"
      ) {
        setViewSelectionPopup(true);
      } else {
        setViewSelectionPopup(false);
      }
      setShowContentPopup(true);
    }
    onBlockBlocks(false);
    setShowContentTypePopup(false);
    setContentPopupTypeConfig(null);
    setContentPopupTypeValue(null);
  };

  const handleOnEditContentPopup = (e, ee, value, f, f2) => {
    updateContent(value);
  };

  const handleOnNewContentPopup = (e, ee, value) => {
    if (value) {
      updateContent(value);
    }
  };

  const handleCloseContentPopup = (value) => {
    setShowContentPopup(false);
    setContentPopupConfig(null);
    setContentPopupTypeConfig(null);
    setContentPopupValue(null);
  };
  const messageError = (title, description) => {
    swal({
      title: title,
      text: description,
      icon: "warning",
      buttons: false,
      dangerMode: true,
    }).then((ok) => {
      if (ok) {
        return;
      }
    });
  };
  const updateContent = (v) => {
    // console.log("update content");
    let found =
      CanvasInfoContent && CanvasInfoContent.find((item) => item.UID == v.UID);
    if (found) {
      dispatch(removeCanvasContentInfo([found]));
    } else {
      // console.log("no");
    }
    let uid = null;
    if (v.UID) uid = v.UID;
    else uid = randomNumberInRange(100000000000, 999999999999);
    let newContent = {
      UID: uid,
      type: v.type,
      new: true,
    };
    switch (v.type) {
      case "staticImage":
        if (v.urlId) newContent.content = JSON.stringify({ urlId: v.urlId });
        else {
          messageError(
            "Insert an image",
            "You can´t save without setting an image"
          );
          return;
        }
        break;

      /*case "backgroundImage":
        if(v.urlId)
          newContent.content=JSON.stringify({urlId:v.urlId});
        else{
          messageError("Insert an image","You can´t save without setting an image");
          return;
        }
        break;*/
      case "interactableGraphics":
        const selector = v.interactableGraphicSelector;
        const configId = selector?.values?.configId;
 
        const isXtadium = selector?.url?.includes("xtadium-calendar");
 
        if (isXtadium && (!configId || configId.toString().trim() === "")) {
            messageError("Missing config ID", "You can’t save without a config ID for Xtadium Calendar");
            return;
        }
       
    const hasSelector = selector && Object.keys(selector).length > 0;
        //in case Custom interactable
    if (!hasSelector) {
        messageError("Insert an interactable graphic", "You can’t save without setting an interactable graphic");
        return;
        }else{
          if(selector.id==9999999999999){
            if(selector.url==""){
            messageError("Insert an interactable graphic", "You can’t save without setting an interactable graphic");
            return;
        }
        try {
            new URL(selector.url);
        } catch {
            messageError("Invalid URL", "The interactable graphic must have a valid URL");
            return;
        }
    }
}
        // In Case Youtube InteractableGraphic
        const isYoutube = selector?.url?.includes("interactableGraphic/youtube");
        const youtubeId = selector?.values?.id;

        if (isYoutube && (!youtubeId || youtubeId.toString().trim() === "")) {
          messageError("Missing YouTube ID", "You can’t save without a YouTube ID for the interactable graphic");
          return;
        }

        newContent.content = JSON.stringify({
            interactableGraphicSelector: selector,
            scalingFactor: v.scalingFactor,
            ...(isAndroidXR ? { height: v.height } : {})
        });
        break;
      case "sportRoom":
        if (v.tableValue) {
          if (Array.isArray(v.tableValue))
            newContent.content = JSON.stringify({
              sportRoomId: v.tableValue[0].id,
            });
          //new
          else
            newContent.content = JSON.stringify({
              sportRoomId: v.tableValue.id,
            }); //edit
        } else {
          messageError(
            "Insert a sport room",
            "You can´t save without setting a sport room"
          );
          return;
        }
        break;
      case "calendar":
        newContent.content = JSON.stringify({
          maxNumElements: v.maxNumElements,
          canvasContainerId: value.canvasContainerId,
        });
        break;
      case "highlightedContent":
        
        if (v.tableValue) {
          let val = null;
          if (Array.isArray(v.tableValue)) {
            val = v.tableValue[0];
          } else {
            val = v.tableValue;
          }
          let res = {};
          if (val.expired) {
            res.expired = val.expired;
          }
          res.contentId = val.id;
          newContent.content = JSON.stringify(res);
        } else {
          messageError(
            "Insert a video content",
            "You can´t save without setting a video content"
          );
          return;
        }

        break;
      case "externalContent":
        if (v.tableValue) {
          let val = null;
          if (Array.isArray(v.tableValue)) {
            val = v.tableValue[0];
          } else {
            val = v.tableValue;
          }
          let res = {};
          if (val.expired) {
            res.expired = val.expired;
          }
          res.contentId = val.id;
          newContent.content = JSON.stringify(res);
        } else {
          messageError(
            "Insert a video content",
            "You can´t save without setting a video content"
          );
          return;
        }

        break;
      case "carousel":
        if (v.tableValue) {
          let ids = v.tableValue.map((item) => {
            if (item.contentType == "highlighted")
              return { id: item.id, type: "highlighted" };
            else if (item.url) {
              return { id: item.id, type: "staticImage" };
            }
          });
          newContent.content = JSON.stringify({
            carouselIds: ids,
            backgroundImage: v.backgroundImage,
            title:v.title
          });
        } else {
          messageError(
            "Insert a carousel element",
            "Insert at least one element to save"
          );
          return;
        }
        break;
      case "spacesCarousel":
        if (v.tableValue) {
          let ids = v.tableValue.map((item) => {
            if (item.contentType == "room")
              return { id: item.id, type: "room" };
            else if (item.url) {
              return { id: item.id, type: "staticImage" };
            }
          });
          newContent.content = JSON.stringify({
            carouselIds: ids,
            backgroundImage: v.backgroundImage,
          });
        } else {
          messageError(
            "Insert a carousel element",
            "Insert at least one element to save"
          );
          return;
        }

        break;
      case "contentCategory":
        if (v.allCategories || v.tableValue) {
          if (v.allCategories) {
            newContent.content = JSON.stringify({ categories: ["all"] });
          } else {
            if (v.tableValue.length == 0) {
              messageError(
                "Insert a category",
                "You can´t save without setting a category"
              );
              return;
            } else {
              let ids = [];
              if (v.tableValue) {
                ids = v.tableValue.map((item) => {
                  return { id: item.id };
                });
              } else {
                ids = [];
              }
              newContent.content = JSON.stringify({ categories: ids });
            }
          }
        } else {
          messageError(
            "Insert a category",
            "You can´t save without setting a category"
          );
          return;
        }
             break;

      case "App2AppTravel": 

      const hasApplicationId =
        typeof v.applicationId === "string" && v.applicationId.trim() !== "";

      const hasDeeplinkMessage =
        typeof v.deepLinkMessage === "string" && v.deepLinkMessage.trim() !== "";

      if (!hasApplicationId || !hasDeeplinkMessage) {
        messageError(
          "Missing required fields",
          "Application ID and Deeplink message are required to save"
        );
        return;
      }

      newContent.content = JSON.stringify(v);
      break;

    }
    let blockUpdated = value;
    blockUpdated["contents"] = newContent;
    onUpdateContent(blockUpdated);

    setShowContentPopup(false);
    setContentPopupConfig(null);
    setContentPopupValue(null);
  };

  // Step 1 select type of content
  const handleAddNewContent = (value, v, canvasMode, size = null) => {
    onBlockBlocks(true);
    let queryString = window.location.pathname;
    let urlNewContentPopup = "canvasNewContentPopup/mainHub";

    if (canvasMode == "Top" || canvasMode == "Bottom") {
      urlNewContentPopup = "canvasNewContentTopBottomPopup";
    } else if (queryString.search("sportrooms") >= 0)
      urlNewContentPopup = "canvasNewContentPopup";

    httpGet(urlNewContentPopup)
      .then((res) => {
        setShowContentTypePopup(true);
        let info = [
          {
            attributeName: "newContent",
            fields: [
              {
                attributeName: "contentsAvailable",
                type: FormInputTypes.GRID_BUTTONS,
                required: true,
              },
            ],
          },
        ];
        setContentPopupTypeConfig(info);
        setContentPopupTypeValue(res);
        setViewSelectionParams({ size: v.size });
      })
      .catch((error) => {});
  };
  const getValuesToPopup = (content) => {
    let c = JSON.parse(content.content);
    switch (content.type) {
      case "contentCategory":
        if (c.categories && c.categories[0] != "all") {
          return {
            tableValue: {
              ids: c.categories,
            },
          };
        } else {
          return { allCategories: true };
        }

        break;
      case "highlightedContent":
        return {
          tableValue: {
            id: c.contentId,
          },
        };
        break;
      case "externalContent":
        return {
          tableValue: {
            id: c.contentId,
          },
        };
        break;
      case "sportRoom":
        return {
          tableValue: {
            id: c.sportRoomId,
          },
        };
        break;
      case "staticImage":
        return {
          urlId: c.urlId,
        };
        break;
      case "calendar":
        return {
          maxNumElements: c.maxNumElements,
          canvasContainerId: c.canvasContainerId,
        };
        break;
      case "interactableGraphics":
        return {
          interactableGraphicSelector: c.interactableGraphicSelector,
          scalingFactor: c.scalingFactor,
          height: c.height ?? (isAndroidXR ? 306 : undefined),
        };
        break;
      case "carousel":
        return {
          backgroundImage: c.backgroundImage,
          title:c.title,
          tableValue: {
            ids: c.carouselIds,
          },
        };
        break;
      case "spacesCarousel":
        return {
          backgroundImage: c.backgroundImage,
          tableValue: {
            ids: c.carouselIds,
          },
        };
        break;
      case "App2AppTravel":
        return c;
        break;
    }
  };
  const handleContentEdit = (size, content) => {
    let config = getConfigContent(content.type);
    setContentPopupConfig(config);
    let values = getValuesToPopup(content);
    setContentPopupValue({ UID: content.UID, type: content.type, ...values });
    setContentPopupIcon(getType(content.type, size));
    setViewSelectionType(content.type);

    setContentPopupSuperTitle(getType(content.type, size, true));

    if (
      content.type == "sportRoom" ||
      content.type == "highlightedContent" ||
      content.type == "externalContent" ||
      content.type == "carousel" ||
      content.type == "contentCategory" ||
      content.type == "spacesCarousel"
    ) {
      setViewSelectionPopup(true);
      switch (content.type) {
        case "highlightedContent":
          setViewSelectionUrl("canvasHighlightedContentInfo");
          setViewSelectionId("contentId");
          setViewSelectionParams({ size: size });

          break;
        case "externalContent":
          setViewSelectionUrl("canvasHighlightedContentInfo");
          setViewSelectionId("contentId");
          setViewSelectionParams({ size: size });

          break;
        case "carousel":
          setViewSelectionUrl("canvasCarouselInfo");
          setViewSelectionId("carouselIds");
          setViewSelectionResultField("carouselItems");
          setViewSelectionParams({ size: size });

          break;
        case "spacesCarousel":
          setViewSelectionUrl("canvasSpacesCarouselInfo");
          setViewSelectionId("carouselIds");
          setViewSelectionResultField("carouselItems");
          setViewSelectionParams({ size: size });
          break;
        case "contentCategory":
          //console.log("cat");
          setViewSelectionUrl("canvasContentCategoryInfo/" + session.areaId);
          setViewSelectionId("categories");
          setViewSelectionParams({ size: size });

          break;
        case "sportRoom":
          //console.log("room");
          setViewSelectionUrl("canvasSportRoomInfo");
          setViewSelectionId("sportRoomId");
          setViewSelectionParams({ size: size });

          break;
      }
    }
    setShowContentPopup(true);
    setShowContentMode("edit");
  };

  const handleContentDelete = () => {
    swal({
      title: "Are you sure?",
      text: "You are about to remove this content",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((ok) => {
      if (ok) {
        let blockUpdated = value;
        blockUpdated["contents"] = null;
        blockUpdated["UID"] = randomNumberInRange();
        onUpdateContent(blockUpdated);
      }
    });
  };

  const handlerButtonInfo = () => {
    let found =
      CanvasInfoContent &&
      CanvasInfoContent.find((item) => item.UID == value.contents.UID);
    if (found) {
      onInfoClicked(value);
    } else {
      loadInfoBlock(value, session,isScrollable, (info) => {
        let newElement = JSON.parse(JSON.stringify(value.contents));
        newElement.info = info;
        onInfoClicked(value);
        onUpdateInfoContent(newElement);
      });
    }
  };

  const handlerButtonAlert = (alerts) => {
    if (alerts.length > 0) {
      let btns = {};
      btns.ok = true;
      var content = document.createElement("div");
      let contentAlerts = alerts.join("<br/>");
      content.innerHTML = "<div>" + contentAlerts + "</div>";
      swal({
        title: "Alert in this content!",
        content: content,
        buttons: btns,
      }).then((value) => {});
    }
  };

  const returnName = 1;
  const returnWrongSizes = 2;
  const getType = (type, size = "XXL", mode = 0) => {
    switch (type) {
      case "sportRoom":
        if (mode == returnName) return "Room";
        else if (mode == returnWrongSizes) {
          return [];
        }
        return (
          <img
            className={
              "canvas-image-icon canvas-image-icon--" +
              size +
              " canvas-image-icon--sportroom"
            }
            src={sportRoomIcon}
          />
        );
        break;
      case "staticImage":
        if (mode == returnName) return "Static graphic";
        else if (mode == returnWrongSizes) {
          return [];
        }
        return (
          <img
            className={
              "canvas-image-icon canvas-image-icon--" +
              size +
              " canvas-image-icon--staticimage"
            }
            src={staticImageIcon}
          />
        );
        break;
      case "backgroundImage":
        if (mode == returnName) return "Background Image";
        else if (mode == returnWrongSizes) {
          return [];
        }
        return (
          <img
            className={
              "canvas-image-icon canvas-image-icon--" +
              size +
              " canvas-image-icon--staticimage"
            }
            src={staticImageIcon}
          />
        );
        break;
      case "calendar":
        if (mode == returnName) return "Calendar icon";
        else if (mode == returnWrongSizes) {
          return ["XS", "S-V", "S-H"];
        }
        return (
          <img
            className={
              "canvas-image-icon canvas-image-icon--" +
              size +
              " canvas-image-icon--calendar"
            }
            src={calendarIcon}
          />
        );
        break;
      case "highlightedContent":
        if (mode == returnName)
          return (
            <>
              <span>Video</span>
            </>
          );
        else if (mode == returnWrongSizes) {
          return ["XS", "S-V", "S-H"];
        }
        return (
          <img
            className={
              "canvas-image-icon canvas-image-icon--" +
              size +
              " canvas-image-icon--highlightedcontent"
            }
            src={highlightedContentIcon}
          />
        );
        break;
      case "externalContent":
        if (mode == returnName)
          return (
            <>
              <span>Video</span>
            </>
          );
        else if (mode == returnWrongSizes) {
          return ["XS", "S-V", "S-H"];
        }
        return (
          <img
            className={
              "canvas-image-icon canvas-image-icon--" +
              size +
              " canvas-image-icon--highlightedcontent"
            }
            src={externalVideoIcon}
          />
        );
        break;
      case "carousel":
        if (mode == returnName) return "Carousel";
        else if (mode == returnWrongSizes) {
          return ["XS", "S-V", "S-H"];
        }
        return (
          <img
            className={
              "canvas-image-icon canvas-image-icon--" +
              size +
              " canvas-image-icon--carousel"
            }
            src={carouselIcon}
          />
        );
        break;
      case "spacesCarousel":
        if (mode == returnName) return "spacesCarousel";
        else if (mode == returnWrongSizes) {
          return ["XS", "S-V", "S-H"];
        }
        return (
          <img
            className={
              "canvas-image-icon canvas-image-icon--" +
              size +
              " canvas-image-icon--carousel"
            }
            src={spacesCarouselIcon}
          />
        );
        break;
      case "interactableGraphics":
        if (mode == returnName) return "Int. graphic";
        else if (mode == returnWrongSizes) {
          return ["XS", "S-V", "S-H"];
        }
        return (
          <img
            className={
              "canvas-image-icon canvas-image-icon--" +
              size +
              " canvas-image-icon--interactablegraphics"
            }
            src={interactableGraphicsIcon}
          />
        );
        break;
      case "contentCategory":
        if (mode == returnName) return "Content category";
        else if (mode == returnWrongSizes) {
          return ["XS", "S-V", "S-H", "XL-V", "XL-H", "L-V", "L-H", "M"];
        }
        return (
          <img
            className={
              "canvas-image-icon canvas-image-icon--" +
              size +
              " canvas-image-icon--contentcategory"
            }
            src={contentCategoryIcon}
          />
        );
        break;
      case "App2AppTravel":
        if (mode == returnName) return "App2App travel";
        else if (mode == returnWrongSizes) {
          return ["XS", "S-V", "S-H", "XL-H", "L-V", "L-H", "M", "XXL"];
        }
        return (
          <img
            className={
              "canvas-image-icon canvas-image-icon--" +
              size +
              " canvas-image-icon--contentcategory"
            }
            src={contentApp2AppTravelIcon}
          />
        );
        break;
    }
    return [];
  };

  const ButtonActions = (props) => {
    const { size, content } = props;
    return (
      <div className={"content-actions" + " content-actions--" + size}>
        <Button
          id={"button-edit-content-" + content.id}
          className="button-action button-edit-content"
          type={"button"}
          onClick={() => handleContentEdit(size, content)}
          icon={IconType.EDIT}
          iconSize={IconSize.SMALL}
          iconColor={"#000000"}
          size={ButtonSize.SMALL}
        ></Button>
        <Button
          id={"button-delete-content-" + content.id}
          className="button-action button-delete-content"
          type={"button"}
          onClick={handleContentDelete}
          icon={IconType.DELETE}
          iconSize={IconSize.SMALL}
          iconColor={"#000000"}
          size={ButtonSize.SMALL}
        ></Button>
      </div>
    );
  };

  const ContentHeader = (props) => {
    const { size, type, content } = props;

    let wrongSize = getType(type, size, returnWrongSizes).includes(size);
    let hasNotImage = false;
    let alerts = [];
    let decodedContent = JSON.parse(content);
    if (decodedContent.expired) alerts.push("This element is expired");
    if (wrongSize)
      alerts.push("The content don´t admit the size (" + size + ")");
    if (hasNotImage)
      alerts.push(
        "The content don´t have an image for this size (" + size + ")"
      );

    return (
      <div className="content-info">
        {type && size && (wrongSize || hasNotImage || decodedContent.expired) && (
          <Button
            id={"button-alert-content"}
            className={"button-alertButton"}
            onClick={() => {
              handlerButtonAlert(alerts);
            }}
          >
            <img src={alertIcon} />
          </Button>
        )}
        <Button
          className={"button-infoButton"}
          theme={ButtonTheme.DARK}
          size={IconSize.SMALL}
          title="info"
          onClick={handlerButtonInfo}
        >
          <img src={infoIcon} />
        </Button>
      </div>
    );
  };
  const Content = (props) => {
    const { size, content } = props;
    switch (size) {
      case "XS":
      case "S-H":
      case "S-V":
        return (
          <>
            <ButtonActions size={size} content={content} />
            <div>
              <div className="content-header-absolute">
                <ContentHeader
                  size={size}
                  type={content.type}
                  content={content.content}
                />
              </div>
            </div>
            <div>
              <div className={"content-icon-text"}>
                {getType(content.type, size)}
                {(content.type == "carousel" ||
                  content.type == "spacesCarousel") &&
                  content.content && (
                    <div>
                      ({JSON.parse(content.content).carouselIds.length})
                    </div>
                  )}
                {content.type == "contentCategory" &&
                  content.content &&
                  Array.isArray(JSON.parse(content.content).categories) && (
                    <div>
                      (
                      {JSON.parse(content.content).categories[0] != "all" &&
                        JSON.parse(content.content).categories.length}
                      {JSON.parse(content.content).categories[0] == "all" && (
                        <span>{JSON.parse(content.content).categories}</span>
                      )}
                      )
                    </div>
                  )}
              </div>
            </div>
          </>
        );
        break;
      default:
        return (
          <div className="content-child">
            <ButtonActions size={size} content={content} />
            <div className="content-body">
              <div className="content-header">
                <ContentHeader
                  size={size}
                  type={content.type}
                  content={content.content}
                />
                {drawContent(content, size)}
              </div>
            </div>
          </div>
        );
    }
  };
  const drawPreviewContent = (value, infoBlock) => {
    let size = getCanvasBlockSize(value.w, value.h,isScrollable);
    switch (value.contents.type) {
      case "interactableGraphics":
        return drawPreviewInteractableGraphics(value, size, infoBlock);
        break;
      case "contentCategory":
        return drawPreviewCategoryContent(value, size, infoBlock);
        break;
      case "staticImage":
        return drawPreviewStaticGrahic(value, size, infoBlock);
        break;
      case "backgroundImage":
        return drawPreviewStaticGrahic(value, size, infoBlock);
        break;
      case "calendar":
        return drawPreviewCalendar(value, size, infoBlock);

      case "sportRoom":
        return drawPreviewStaticGrahic(value, size, infoBlock);
      case "highlightedContent":
      case "externalContent":
        return drawPreviewHighlightedContent(value, size, infoBlock);
        break;
      case "carousel":
        return drawPreviewCarousel(value, size, infoBlock);
        break;
      case "spacesCarousel":
        return drawPreviewSpacesCarousel(value, size, infoBlock);
        break;
      case "App2AppTravel":
        return drawPreviewApp2AppTravel(value, size, infoBlock);
    }
  };
  const contentCategorySelCategory = (uid, value) => {
    let newSelected = null;
    let found = categoryContentSelected.find((item) => item.uid == uid);
    if (!found) {
      newSelected = { uid: uid, value: value };
      setCategoryContentSelected([...categoryContentSelected, newSelected]);
    } else {
      const newSel = [...categoryContentSelected];
      found.value = value;
      setCategoryContentSelected(newSel);
    }
    setImagesLoaded([]);
  };
  const carouselRight = (uid) => {
    let newSelected = null;
    let found = carouselSelected.find((item) => item.uid == uid);
    if (!found) {
      newSelected = { uid: uid, value: 2 };
      setCarouselSelected([...carouselSelected, newSelected]);
    } else {
      const newSel = [...carouselSelected];
      found.value = found.value + 1;
      setCarouselSelected(newSel);
    }
  };
  const carouselLeft = (uid) => {
    let newSelected = null;
    let found = carouselSelected.find((item) => item.uid == uid);
    if (!found) {
      newSelected = { uid: uid, value: 1 };
      setCarouselSelected([...carouselSelected, newSelected]);
    } else {
      const newSel = [...carouselSelected];
      if (found.value != 1) found.value = found.value - 1;
      setCarouselSelected(newSel);
    }
  };
  const loadImages = (videos, id) => {
    var promise = new Promise((resolve, reject) => {
      if (imagesLoaded.length != videos.length) {
        let ids = [];
        for (let video of videos) {
          ids.push(video[id]);
        }

        let url = "downloadableUrls";
        httpPost(url, { ids: ids })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            console.log("error", error);
          });
      }
    });
    return promise;
  };
  const loadImage = (id) => {
    var promise = new Promise((resolve, reject) => {
      if (id != null) {
        let url = "downloadableUrl/" + id;
        httpGet(url)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            console.log("Error loading images" + id);
            resolve(null);
          });
      } else resolve(null);
    });
    return promise;
  };

  const drawCategoryVideos = (categories, categorySelIndex) => {
    let videos = categories[categorySelIndex];
    if (imagesLoaded.length == 0) {
      loadImages(videos.content, "poster").then((urls) => {
        setTimeout(() => {
          let d = new Date().getTime();
          urls.time = d;
          setImagesLoaded(urls);
        }, 500);
      });
    }
    return (
      <>
        <div className="number">
          {videos.content.length} Videos on this category
        </div>
        {videos.content &&
          videos.content.map((video, index) => {
            let found = imagesLoaded.find((item) => item.id == video.poster);
            let image = null;
            if (found) {
              image = found.value;
            } else {
              image = null;
            }
            return (
              <div className="preview-image preview-image--poster" key={index}>
                <div className="preview-image preview-image--poster-image">
                  <img src={image == null ? videoPosterNoImage : image} />
                </div>
                <div className="preview-image preview-image--poster-name">
                  {video.name}
                </div>
              </div>
            );
          })}
      </>
    );
  };

  const drawPreviewCategoryContent = (value, size, infoBlock) => {
    let found = categoryContentSelected.find((item) => item.uid == value.UID);
    let categories = infoBlock.info;
    // let categories = value.contents.info;

    return (
      <div className="preview-content-category">
        <div className="preview-content-category-header">
          {categories.map((cat, index) => {
            return (
              <div
                onClick={() => contentCategorySelCategory(value.UID, index)}
                key={index}
                className={
                  "preview-content-category-title" +
                  (found && found.value == index ? " selected" : "")
                }
              >
                <div>{cat.name}</div>
              </div>
            );
          })}
        </div>
        <div className="preview-content-category-body">
          <div className="preview-content-category-videos">
            {found
              ? drawCategoryVideos(categories, found.value)
              : "SELECT ONE CATEGORY"}
          </div>
        </div>
      </div>
    );
  };
 const drawPreviewApp2AppTravel = (value, size, infoBlock) => {
  const image = infoBlock?.info?.defaultUrl;

  return (
    <div
      style={{
        border: "1px solid #000000",
        backgroundColor: "#939393",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      {image && (
        <img
          className={"preview-image preview-image--" + size}
          src={image}
          alt="App2App Travel Preview"
          onError={(e) => {
            e.target.src = imgNoImage(value, size, "app2AppTravel");
          }}
        />
      )}
    </div>
  );
};

  const drawPreviewCarousel = (value, size, infoBlock) => {
    let found = carouselSelected.find((item) => item.uid == value.UID);
    let sel = 1;
    if (found) {
      sel = found.value;
    }
    let longSize = getLongSize(size);
    let image = null;
    if (infoBlock.info.carouselItems[sel - 1].contentType == "highlighted") {
      image = infoBlock.info.carouselItems[sel - 1][longSize];
    } else {
      image = infoBlock.info.carouselItems[sel - 1]["id"];
    }
    loadImage(image).then((res) => {
      if (res == null)
        setCarouselImageSelected(imgNoImage(value, size, "carousel"));
      else {
        setCarouselImageSelected(res);
      }
    });

    return (
      <div className={"preview-carousel-content"}>
        {value && value.contents && (
          <img
            className={"preview-image preview-image--" + size + " highlighted"}
            src={carouselImageSelected}
          />
        )}
        <div className="preview-carousel-item">
          Carousel {sel + "/" + infoBlock.info.carouselItems.length}
        </div>
        <div className="preview-carousel-footer">
          {infoBlock.info.carouselItems[sel - 1].name}
        </div>
        <div className="preview-carousel-buttons">
          <Button
            key={`button-add-content-left`}
            className={"mr-2 " + "button " + "button-left button--" + size}
            id={canvasMode + `-button-add-content`}
            type={ButtonType.BUTTON}
            theme={ButtonTheme.DARK}
            title={"<"}
            disabled={sel == 1}
            onClick={() => {
              carouselLeft(value.UID);
            }}
          >
            &lt;
          </Button>
          <Button
            key={`button-add-content-right`}
            className={"mr-2 " + "button " + "button-right button--" + size}
            id={canvasMode + `-button-add-content`}
            type={ButtonType.BUTTON}
            theme={ButtonTheme.DARK}
            title={">"}
            disabled={sel == infoBlock.info.carouselItems.length}
            onClick={() => {
              carouselRight(value.UID);
            }}
          >
            &gt;
          </Button>
        </div>
      </div>
    );
  };

  const drawPreviewSpacesCarousel = (value, size, infoBlock) => {
    let found = carouselSelected.find((item) => item.uid == value.UID);
    let sel = 1;
    if (found) {
      sel = found.value;
    }
    let longSize = getLongSize(size);
    let image = null;
    if (infoBlock.info.carouselItems[sel - 1].contentType == "room") {
      image = infoBlock.info.carouselItems[sel - 1][longSize];
    } else {
      image = infoBlock.info.carouselItems[sel - 1]["id"];
    }
    loadImage(image).then((res) => {
      if (res == null)
        setCarouselImageSelected(imgNoImage(value, size, "spacesCarousel"));
      else {
        setCarouselImageSelected(res);
      }
    });

    return (
      <div className={"preview-spacesCarousel-content"}>
        {value && value.contents && (
          <img
            className={"preview-image preview-image-spacesCarousel--" + size + " sportRoom"}
            src={carouselImageSelected}
          />
        )}
        <div className="preview-spacesCarousel-item">
          spacesCarousel {sel + "/" + infoBlock.info.carouselItems.length}
        </div>
        <div className="preview-spacesCarousel-footer">
          {infoBlock.info.carouselItems[sel - 1].name}
        </div>
        <div className="preview-spacesCarousel-buttons">
          <Button
            key={`button-add-content-left`}
            className={"mr-2 " + "button " + "button-left button--" + size}
            id={canvasMode + `-button-add-content`}
            type={ButtonType.BUTTON}
            theme={ButtonTheme.DARK}
            title={"<"}
            disabled={sel == 1}
            onClick={() => {
              carouselLeft(value.UID);
            }}
          >
            &lt;
          </Button>
          <Button
            key={`button-add-content-right`}
            className={"mr-2 " + "button " + "button-right button--" + size}
            id={canvasMode + `-button-add-content`}
            type={ButtonType.BUTTON}
            theme={ButtonTheme.DARK}
            title={">"}
            disabled={sel == infoBlock.info.carouselItems.length}
            onClick={() => {
              carouselRight(value.UID);
            }}
          >
            &gt;
          </Button>
        </div>
      </div>
    );
  };
  const drawPreviewHighlightedContent = (value, size, infoBlock) => {
    let image;
    // if(value.contents.info.image==undefined)
    if (infoBlock.info.image == undefined) image = imgNoImage(value, size);
    else image = infoBlock.info.image;

    // image=value.contents.info.image;

    return (
      <div className="preview-highlighted-content">
        <img
          className={"preview-image preview-image--" + size + " highlighted"}
          src={image}
        />
        <div className={"preview-footer preview-footer--" + size}>
          {infoBlock.info.name}
        </div>
      </div>
    );
  };
  const drawPreviewStaticGrahic = (value, size, infoBlock) => {
    const src =
      infoBlock?.info?.image !== undefined
        ? infoBlock.info.image
        : imgNoImage(value, size);

    const fallback = imgNoImage(value, size);

    return <CanvasPreviewImage src={src} fallbackSrc={fallback} size={size} />;
  };

  const drawPreviewCalendar = (value, size, infoBlock) => {
    return (
      <IframeCustom
        id={"preview-calendar"}
        src={infoBlock.info.image}
        height={"100%"}
        width={"100%"}
      />
    );
  };

  const drawPreviewInteractableGraphics = (value, size, infoBlock) => {
    return (
      <IframeCustom src={infoBlock.info.image} height={"100%"} width={"100%"} />
      // <iframe
      //   is="x-frame-bypass"
      //   seamless="seamless"
      //   marginHeight="0" marginWidth="0"
      //   scrolling="no" frameBorder="0"
      //   allowtransparency="true" width="100%"
      //   height="100%" src={infoBlock.info.image}>
      // </iframe>
    );
  };
  const getText = (number, text) => {
    if (number == 1) {
      return "(" + number + " " + text + ")";
    } else {
      return "(" + number + " " + text + "s)";
    }
  };
  const drawContent = (content, size) => {
    return (
      <div>
        <div className={"content-type" + " content-type--" + content.size}>
          {getType(content.type, size)}
          <div className="content-type-name">
            {" "}
            {getType(content.type, size, true)}
          </div>
          {content.type == "carousel" && content.content && (
            <div className="carousel-elements">
              {getText(
                JSON.parse(content.content).carouselIds.length,
                "Content"
              )}
            </div>
          )}
          {content.type == "contentCategory" && content.content && (
            <div>
              {getText(
                JSON.parse(content.content).categories.length,
                "Element"
              )}
            </div>
          )}
          {content.type == "spacesCarousel" && content.content && (
            <div className="spacesCarousel-elements">
              {getText(
                JSON.parse(content.content).carouselIds.length,
                "SportRoom"
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  const imgNoImage = (value, size, mode) => {
    if (value) {
      switch (size) {
        case "XXL":
          if (mode == "carousel" || mode == "spacesCarousel")
            return noImageXXLCarousel;
          else return noImageXXL;
          break;
        case "XL-V":
          if (mode == "carousel" || mode == "spacesCarousel")
            return noImageXLVCarousel;
          else return noImageXLV;
          break;
        case "XL-H":
          if (mode == "carousel" || mode == "spacesCarousel")
            return noImageXLHCarousel;
          else return noImageXLH;
          break;
        case "L-V":
          if (mode == "carousel" || mode == "spacesCarousel")
            return noImageLVCarousel;
          else return noImageLV;
          break;
        case "L-H":
          if (mode == "carousel" || mode == "spacesCarousel")
            return noImageLHCarousel;
          else return noImageLH;
          break;
        case "M":
          if (mode == "carousel" || mode == "spacesCarousel")
            return noImageMCarousel;
          else return noImageM;
          break;
        case "S-V":
          if (mode == "carousel" || mode == "spacesCarousel")
            return noImageSVCarousel;
          else return noImageSV;
          break;
        case "S-H":
          if (mode == "carousel" || mode == "spacesCarousel")
            return noImageSHCarousel;
          else return noImageSH;
          break;
        case "XS":
          if (mode == "carousel" || mode == "spacesCarousel")
            return noImageXSCarousel;
          else return noImageXS;
          break;
        case "S-FW":
          if (mode == "carousel" || mode == "spacesCarousel")
            return noImageSFWCarousel;
          else return noImageSFW;
          break;
      }
    }
  };

  return (
    <>
      <div className={"content-container content-container--" + size}>
        {/* mode backend */}
        {(!mode || mode == 1) && (
          <div className="content-box">
            <div
              className={
                "content" +
                (!value.contents || value.contents == null
                  ? " content--empty"
                  : "") +
                (isInit ? " content--init" : "")
              }
            >
              <div className={isInit ? "content--init-block" : ""}></div>
              {(!value.contents || value.contents == null) && (
                <Button
                  key={canvasMode + `-button-add-content-` + value.UID}
                  className={
                    "mr-2 " +
                    "button " +
                    " button--" +
                    size +
                    " " +
                    canvasMode +
                    `-button-add-content`
                  }
                  id={canvasMode + `-button-add-content-` + value.UID}
                  type={ButtonType.BUTTON}
                  icon={IconType.NEW}
                  theme={ButtonTheme.DARK}
                  title={"Add new content"}
                  onClick={() => {
                    handleAddNewContent(
                      value.contents,
                      value,
                      canvasMode,
                      value.size
                    );
                  }}
                >
                  {size != "XS" && <span> Add new content</span>}
                </Button>
              )}
              {/* if there´s content on the block */}
              {value.contents && value.contents != null && (
                <Content content={value.contents} size={size} />
              )}
            </div>
          </div>
        )}
        {/* MODE FRONTEND / PREVIEW */}
        {mode == 2 && (
          <div
            className={
              "preview-image" +
              (blockSelectedPreview == value.UID ? " block-selected" : "")
            }
          >
            {value &&
              value.contents &&
              infoBlock &&
              drawPreviewContent(value, infoBlock)}
          </div>
        )}
      </div>
      <FormPopup
        show={showContentTypePopup}
        value={contentPopupTypeValue}
        configFile={contentPopupTypeConfig}
        extraClassName={"gridButtons"}
        size={"block"}
        title={"Choose one element"}
        onClosePopup={handleCloseContentTypePopup}
      />
      <FormPopup
        mode={showContentMode}
        show={showContentPopup}
        value={contentPopupValue}
        icon={contentPopupIcon}
        superTitle={contentPopupSuperTitle}
        configFile={contentPopupConfig}
        extraClassName={"gridButtons"}
        size={"xl"}
        title={"Choose one element"}
        viewSelection={viewSelectionPopup}
        viewSelectionType={viewSelectionType ? viewSelectionType : null}
        viewSelectionUrl={viewSelectionUrl}
        viewSelectionId={viewSelectionId}
        viewSelectionParams={viewSelectionParams}
        viewSelectionResultField={viewSelectionResultField}
        onClosePopup={handleCloseContentPopup}
        onNewPopup={handleOnNewContentPopup}
        onEditPopup={handleOnEditContentPopup}
        spaceName={session.spaceName}
      />
    </>
  );
};

CanvasContentComponent.propTypes = {};

CanvasContentComponent.defaultProps = {};
export default CanvasContentComponent;
